import translations from '~/i18n/locales/nl.json';
window.translations = translations;
